import { render, staticRenderFns } from "./DropdownLabel.vue?vue&type=template&id=492c877a&"
import script from "./DropdownLabel.vue?vue&type=script&lang=js&"
export * from "./DropdownLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports